/**
 * Enum for all PostHog analytics events used throughout the application.
 * This ensures consistency when capturing events and helps with autocompletion.
 */
export enum AnalyticsEvent {
  // Game joining events
  JoinedGameFromList = "joined_game_from_list",
  JoinedGameFromFriends = "joined_game_from_friends",

  // Room events
  JoinedRoom = "joined_room",
  LeavedRoom = "leaved_room",
  CreatedRoom = "created_room",

  // Game events
  StartedGame = "started_game",
  FinishedGame = "finished_game",
  ClickedGetReady = "clicked_get_ready",

  // Coin/Currency events
  SwapCoinsModalOpen = "swap_coins_modal_open",
  StarsToppedUp = "stars_topped_up",
  TopupStarsModalOpen = "topup_stars_modal_open",
  CustomItemBuying = "custom_item_buying",

  // App events
  StartedApp = "started_app",
  ClickedQuickGame = "clicked_quick_game",

  // Navigation events
  OpenedProfile = "opened_profile",
  OpenedCustoms = "opened_customs",
  OpenedQuests = "opened_quests",
  OpenedFriends = "opened_friends",
  OpenedTop = "opened_top",
  OpenedCreateGame = "opened_create_game",
  BackToHome = "back_to_home",

  // Profile events
  ClickedProfileBalance = "clicked_profile_balance",
  ClickedProfileStats = "clicked_profile_stats",
  ClickedBuyCoins = "clicked_buy_coins",
  ClickedExchangeCoins = "clicked_exchange_coins",
  ProfileStatisticsViewed = "profile_statistics_viewed",

  // Game actions
  TookCard = "took_card",
  PlayedCard = "played_card",
  CalledUno = "called_uno",
  PlayerSurrendered = "player_surrendered",
  ClickedPass = "clicked_pass",
  SelectedColor = "selected_color",
  EnabledBlackCard = "enabled_black_card",
  ClickedShareGame = "clicked_share_game",
  UsedEmoji = "used_emoji",
  OpenedPlayerProfile = "opened_player_profile",
  AddedFriendFromGame = "added_friend_from_game",

  // Customs events
  SwitchedToMarket = "switched_to_market",
  SwitchedToInventory = "switched_to_inventory",
  CustomItemSelected = "custom_item_selected",
  CustomItemApplied = "custom_item_applied",
  CustomPurchaseCompleted = "custom_purchase_completed",
  SelectedPaymentMethod = "selected_payment_method",
  CustomPurchaseInitiated = "custom_purchase_initiated",
  CustomPurchaseConfirmed = "custom_purchase_confirmed",
  CustomPurchaseAbandoned = "custom_purchase_abandoned",
  CustomPurchaseFailed = "custom_purchase_failed",
  CustomPurchaseCancelled = "custom_purchase_cancelled",

  // Quests events
  QuestStarted = "quest_started",
  QuestCompleted = "quest_completed",
  AdWatched = "ad_watched",
  AdSkipped = "ad_skipped",
  QuestClaimed = "quest_claimed",

  // Friends/Social events
  InviteFriend = "invite_friend",
  AddedFriend = "added_friend",
  AcceptedFriend = "accepted_friend",
  SharedReferralLink = "shared_referral_link",
  ViewedLeaderboard = "viewed_leaderboard",

  // Settings/Preferences
  ChangedLanguage = "changed_language",
  ToggledDarkMode = "toggled_dark_mode",
  SortedLeaderboard = "sorted_leaderboard",
  FilteredGames = "filtered_games",

  // Modal/UI events
  OpenedModal = "opened_modal",
  ClosedModal = "closed_modal",
  ClickedHelp = "clicked_help",
  ViewedTooltip = "viewed_tooltip",
  UsedSearch = "used_search",

  // Bonus events
  ClaimedDailyBonus = "claimed_daily_bonus",
  ViewedDailyBonus = "viewed_daily_bonus",
  MissedDailyBonus = "missed_daily_bonus",

  // Error events
  EncounteredError = "encountered_error",
  NotEnoughFunds = "not_enough_funds",
  ConnectionError = "connection_error",
}
